const TENANT_ID_KEY = 'selectedTenantId'
const TAB_CHANNEL = 'tenant-of-open-tab'
const ANSWER_TIMEOUT_MS = 200

interface TenantQuery { type: 'query', requestId: string, page: string }
interface TenantAnswer { type: 'answer', requestId: string, tenantId: string }

export const getSelectedTenantId = (): string | null => {
  const pinnedToTab = sessionStorage.getItem(TENANT_ID_KEY)
  if (pinnedToTab) return pinnedToTab

  const lastSelected = localStorage.getItem(TENANT_ID_KEY)
  if (!lastSelected) return null

  // Pin the carried-over tenant to this tab, so switching tenant in another tab cannot retarget it.
  sessionStorage.setItem(TENANT_ID_KEY, lastSelected)
  return lastSelected
}

export const setSelectedTenantId = (tenantId: string): void => {
  sessionStorage.setItem(TENANT_ID_KEY, tenantId)
  localStorage.setItem(TENANT_ID_KEY, tenantId)
}

export const clearSelectedTenantId = (): void => {
  sessionStorage.removeItem(TENANT_ID_KEY)
  localStorage.removeItem(TENANT_ID_KEY)
}

const pageOf = (url: URL): string => url.pathname + url.search

let answeringChannel: BroadcastChannel | undefined

export const answerTenantQueries = (): void => {
  if (typeof BroadcastChannel === 'undefined') return

  answeringChannel?.close()
  const channel = new BroadcastChannel(TAB_CHANNEL)
  answeringChannel = channel
  channel.onmessage = (event: MessageEvent<TenantQuery>) => {
    const tenantId = sessionStorage.getItem(TENANT_ID_KEY)
    if (event.data.type !== 'query' || !tenantId) return
    if (event.data.page !== pageOf(new URL(globalThis.location.href))) return

    const answer: TenantAnswer = { type: 'answer', requestId: event.data.requestId, tenantId }
    channel.postMessage(answer)
  }
}

const askOpenerTabForTenant = async (): Promise<string | null> => {
  if (typeof BroadcastChannel === 'undefined' || !document.referrer) return null

  const referrer = new URL(document.referrer)
  if (referrer.origin !== globalThis.location.origin) return null

  const requestId = crypto.randomUUID()
  const channel = new BroadcastChannel(TAB_CHANNEL)
  try {
    return await new Promise<string | null>(resolve => {
      const timeout = setTimeout(() => resolve(null), ANSWER_TIMEOUT_MS)
      channel.onmessage = (event: MessageEvent<TenantAnswer>) => {
        if (event.data.type !== 'answer' || event.data.requestId !== requestId) return
        clearTimeout(timeout)
        resolve(event.data.tenantId)
      }
      const query: TenantQuery = { type: 'query', requestId, page: pageOf(referrer) }
      channel.postMessage(query)
    })
  } finally {
    channel.close()
  }
}

export const adoptTenantFromOpenerTab = async (): Promise<void> => {
  if (sessionStorage.getItem(TENANT_ID_KEY)) return

  try {
    const tenantId = await askOpenerTabForTenant()
    if (tenantId) sessionStorage.setItem(TENANT_ID_KEY, tenantId)
  } catch {
    // crypto.randomUUID is missing on non-secure origins; the localStorage seed is the fallback.
  }
}